/*
This file acts as an alias for the class name package currently installed.
In the event Storefront needs to use a different class name library,
just replace the import from this file with the new one and the entire
codebase will be updated.
*/

import { extendTailwindMerge } from "tailwind-merge";
import clsx, { ClassValue } from "../../../node_modules/clsx";

/** This is only needed until we get to Tailwind V4 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      shadow: [
        {
          "text-shadow": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900",
          ],
        },
      ],
    },
  },
});

export const cls = (...classes: ClassValue[]) => twMerge(clsx(...classes));
